import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GatedPrice } from "./GatedPrice";
import { Countdown } from "./Countdown";

export const DealCard = ({ deal, index = 0 }) => {
  const soldOut = deal.stock_remaining <= 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group border border-[#27272A] bg-[#111111] flex flex-col hover:border-[#FFCC00] transition-colors duration-200"
    >
      <Link to={`/deal/${deal.slug}`} data-testid={`deal-card-${deal.slug}`} className="flex flex-col h-full">
        <div className="relative overflow-hidden aspect-[4/3]">
          <img
            src={deal.images[0]}
            alt={deal.title}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-500"
          />
          <span className="absolute top-3 left-3 bg-black/80 border border-[#27272A] text-[10px] uppercase tracking-widest px-2 py-1 text-white/70">
            {deal.condition}
          </span>
          {soldOut && (
            <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
              <span className="font-display text-3xl text-[#FF3B30]">GONE</span>
            </div>
          )}
        </div>
        <div className="p-5 flex flex-col gap-3 flex-1">
          <div className="flex justify-between items-center text-[10px] uppercase tracking-widest text-white/40">
            <span>{deal.sku}</span>
            <span>{deal.units} units</span>
          </div>
          <h3 className="font-display text-xl leading-tight text-white group-hover:text-[#FFCC00] transition-colors duration-150">
            {deal.title}
          </h3>
          <div className="mt-auto flex items-end justify-between gap-2">
            <GatedPrice deal={deal} />
            {deal.status === "live" && !soldOut && (
              <div className="text-right">
                <div className="text-[10px] uppercase text-white/40">Ends in</div>
                <Countdown endsAt={deal.ends_at} />
              </div>
            )}
          </div>
          {deal.status === "live" && !soldOut && (
            <div className="text-[10px] uppercase tracking-widest text-[#FF3B30]">
              {deal.stock_remaining} lots left
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
};
